/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, Input} from '@angular/core';

@Component({
  standalone: false,
  selector: 'adn-report-template-route-page',
  template: `
    <adn-report-template-list-page
      [readOnly]="readOnly">
    </adn-report-template-list-page>
  `
})
export class ReportTemplateRoutePageComponent {
  @Input() readOnly = false;
}
